import React, { useMemo } from 'react';
import { TariffVerificationTypeEnum } from '@src/core/buyerApiClient';
import { useAppSelector } from '@src/core/hooks';
import { tariffVerificationsSelector } from '@src/stores/product';

import { NoteRoot, NoteText } from './styles';
import type { TariffBinVerificationNoteProps } from './types';

const TariffBinVerificationNote = ({ tariffTypeId }: TariffBinVerificationNoteProps) => {
  const tariffTypeVerifications = useAppSelector(tariffVerificationsSelector(tariffTypeId));

  const helperTexts = useMemo(
    () =>
      tariffTypeVerifications
        .filter((v) => v.tariffVerification.type === TariffVerificationTypeEnum.BinCode)
        .map((v) => v.tariffVerification.helperText)
        .filter((text): text is string => !!text),
    [tariffTypeVerifications],
  );

  if (helperTexts.length === 0) return null;

  return (
    <>
      {helperTexts.map((text, i) => (
        <NoteRoot key={i}>
          <NoteText>{text}</NoteText>
        </NoteRoot>
      ))}
    </>
  );
};

export default TariffBinVerificationNote;
